import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { UserPaymentsMain } from './components/UserPaymentsMain'
import { UserPaymentsScope } from './components/UserPaymentsScope'

export const UserPayments = () => {
  return (
    <NuqsAdapter>
      <UserPaymentsScope>
        <UserPaymentsMain />
      </UserPaymentsScope>
    </NuqsAdapter>
  )
}
